// extracted by mini-css-extract-plugin
export var comingSoonContainer = "ComingSoon-module--comingSoonContainer--2zOf4";
export var blueBtn = "ComingSoon-module--blueBtn--2N58Q";
export var imageContainer = "ComingSoon-module--imageContainer--3TmVU";
export var image = "ComingSoon-module--image--3RAfe";